export const ADD_TOAST = 'ADD_TOAST' as const;
export const UPSERT_TOAST = 'UPSERT_TOAST' as const;
export const UPDATE_TOAST = 'UPDATE_TOAST' as const;
export const DISMISS_TOAST = 'DISMISS_TOAST' as const;
export const REMOVE_TOAST = 'REMOVE_TOAST' as const;
export const START_PAUSE = 'START_PAUSE' as const;
export const END_PAUSE = 'END_PAUSE' as const;
